import { Dispatch, Action } from 'redux'
import { UpgradeWorkspaceMainMapDispatchReturnType } from './types/UpgradeWorkspaceMainMapDispatchReturnType'

export const UpgradeWorkspaceMainMapDispatch = (
  _dispatch: Dispatch<Action>
): UpgradeWorkspaceMainMapDispatchReturnType => {
  return {}
}
